import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const teStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'WhatsApp లో ఆహ్వానించండి',
  NLSWhatsappInviteDialogTitle: 'WhatsApp లో ఆహ్వానించండి',
  NLSWhatsappInviteDialogCopy: 'లింక్ కాపీ చేయండి',
  NLSWhatsappInviteDialogShare: 'భాగస్వామ్యం చేయండి',
  NLSWhatsappSendFromMineAction: 'నా WhatsApp నుండి పంపండి',
  NLSWhatsappSendFromMineText: 'నమస్కారం {name}, ఇది {workspace} నుండి {sender}.',
  NLSWhatsappSlipQrCaption: 'WhatsApp లో మాతో చాట్ చేయండి',
  NLSWhatsappChipLinked: 'వాట్సాప్ లింక్ చేయబడింది',
  NLSWhatsappChipNotYet: 'వాట్సాప్: ఇంకా లేదు',
  NLSWhatsappChipStopped: 'వాట్సాప్: నిలిపివేయబడింది',
  NLSEduAnnouncementSendWhatsappAction: 'వాట్సాప్‌లో పంపండి',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'వాట్సాప్‌లో పంపండి',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'పంపు',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: '{n} సంరక్షకులకు పంపబడుతుంది',
  NLSEduAnnouncementSendWhatsappSummaryCredits: '{n} సంరక్షకులకు పంపబడుతుంది · దాదాపు {credits} క్రెడిట్‌లు',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'మీ ప్లాన్ పరిమితి కింద ఉచితం',
  NLSEduAnnouncementSendWhatsappReasonOff: 'ఈ వర్క్‌స్పేస్ కోసం వాట్సాప్ నిలిపివేయబడింది.',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'సెట్టింగ్‌లలో అడ్మిన్ ప్రకటనల పంపకం ఆపివేయబడింది.',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'ధృవీకరించబడిన ఫోన్ సమ్మతి ఉన్న సంరక్షకులు ఎవరూ కనుగొనబడలేదు.',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'సరిపడా క్రెడిట్‌లు లేకపోవడం వల్ల వాట్సాప్ పంపడం పాజ్ చేయబడింది.',
  NLSEduAnnouncementSentWhatsappCount: 'వాట్సాప్‌లో {count} మందికి పంపబడింది',
  NLSCommonRailPageShellSidecarSheet: "వివరాల ప్యానెల్",
  NLSCommonActionSignOut: 'సైన్ అవుట్',
  NLSCommonLanguageLabel: 'భాష',
  NLSCommonLanguageAriaLabel: 'యాప్ భాష',
  NLSInvitesHelperAppLanguageTitle: 'Helper యాప్ భాష',
  NLSInvitesHelperAppLanguageBody: 'ఈ workspace‌లో ఈ helper‌కు Helper యాప్ UI ఈ భాషలో కనిపిస్తుంది.',
  NLSInvitesHelperAppLanguageAria: 'Helper యాప్ భాష',
  NLSMobileSettingsHelperAppLanguageTitle: 'Helper యాప్ భాష',
  NLSMobileSettingsHelperAppLanguageBody: 'Helper యాప్ బటన్‌లు, settings, UI మాత్రమే మారతాయి. Chat translation మారదు.',
  NLSMobileSettingsHelperAppLanguageSaved: 'Helper యాప్ భాష సేవ్ అయింది.',
  NLSHelperTabTodos: 'పనులు',
  NLSHelperTabCalendar: 'క్యాలెండర్',
  NLSHelperTabMeetings: 'మీటింగ్‌లు',
  NLSHelperTabChat: 'చాట్',
  NLSHelperTabControls: 'కంట్రోల్స్',
  NLSHelperSubtabScan: 'స్కాన్',
  NLSHelperSubtabMe: 'నేను',
  NLSHelperSubtabForms: 'ఫారమ్‌లు',
  NLSHelperSubtabSync: 'సింక్',
  NLSHelperPanelSettings: 'Helper settings',
  NLSHelperPanelCommandPreferences: 'Command preferences',
  NLSHelperSettingsTitle: 'Settings',
  NLSHelperSettingsLanguage: 'భాష',
  NLSHelperSettingsLanguageAria: 'Helper భాష',
  NLSOpsRequestKindReliefNeeded: 'రిలీఫ్ అవసరం',
  NLSOpsRequestKindIncident: 'సంఘటన',
  NLSOpsRequestKindClientComplaint: 'క్లయింట్ ఫిర్యాదు',
  NLSOpsRequestKindSupplyRequest: 'సరఫరా అభ్యర్థన',
  NLSOpsRequestKindPm: 'నివారణ నిర్వహణ',
  NLSOpsRequestKindCalibration: 'కాలిబ్రేషన్',
  NLSOpsReliefNeededTitle: 'రిలీఫ్ అవసరం: {placeName} వద్ద {roleLabel} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'సైట్ మరియు షిఫ్ట్ వారీగా డ్యూటీ పోస్ట్‌లు · హాజరుకాని సందర్భంలో రిలీఫ్ అభ్యర్థన వస్తుంది',
  NLSOpsSitesSelectSite: 'సైట్‌ను ఎంచుకోండి',
  NLSOpsSitesDay: 'రోజు',
  NLSOpsSitesSelectShift: 'షిఫ్ట్‌ను ఎంచుకోండి',
  NLSOpsSitesPostsBoardTitle: 'పోస్ట్‌లు & రిలీఫ్',
  NLSOpsSitesColPost: 'పోస్ట్',
  NLSOpsSitesColNeeds: 'అవసరం',
  NLSOpsSitesColOnDuty: 'డ్యూటీలో',
  NLSOpsSitesColState: 'స్థితి',
  NLSOpsSitesStateCovered: 'కవర్ చేయబడింది',
  NLSOpsSitesStateShort: 'తక్కువ',
  NLSOpsSitesStateReliefNeeded: 'రిలీఫ్ అవసరం',
  NLSOpsSitesStateReliefAssigned: 'రిలీఫ్ కేటాయించబడింది',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'హాజరుకాలేదు',
  NLSOpsSitesReliefInbox: 'రిలీఫ్ ఇన్‌బాక్స్',
  NLSOpsSitesReliefFootnote: 'రోల్‌లో గైర్హాజరు స్వయంచాలకంగా RELIEF_NEEDEDని లేవనెత్తుతుంది మరియు కవరేజ్ హెచ్చరికను ఇస్తుంది (A6)。',
  NLSOpsSitesFreeCandidates: 'అందుబాటులో ఉన్న అభ్యర్థులు:',
  NLSOpsSitesOffToday: 'ఈరోజు సెలవు',
  NLSOpsSitesAssignBtn: 'కేటాయించు',
  NLSOpsSitesAssignCandidateBtn: '{name}ను కేటాయించు',
  NLSOpsSitesAssignDialogTitle: 'రిలీఫ్ కేటాయించండి',
  NLSOpsSitesPrintPostSheet: 'పోస్ట్ షీట్‌ను ప్రింట్ చేయండి',
  NLSOpsSitesNoPosts: 'ఈ సైట్ కోసం ఎటువంటి డ్యూటీ పోస్ట్‌లు కాన్ఫిగర్ చేయబడలేదు.',
  NLSOpsSitesNoReliefNeeded: 'ఎలాంటి రిలీఫ్ అవసరం లేదు.',
  NLSOpsSitesNoSites: 'క్లయింట్ సైట్‌లు కనుగొనబడలేదు.',
  NLSOpsSitesNoShifts: 'షిఫ్ట్‌లు అందుబాటులో లేవు.',
  NLSOpsSitesPostSheetTitle: 'పోస్ట్ షీట్ · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'రిలీఫ్ కేటాయించలేము: అభ్యర్థన ఇకపై ఓపెన్‌లో లేదు.',
  NLSOpsSitesErrorOnLeave: 'రిలీఫ్ కేటాయించలేము: సదరు వ్యక్తి ఆమోదించబడిన సెలవులో ఉన్నారు.',
  NLSOpsSitesErrorDoubleBooked: 'రిలీఫ్ కేటాయించలేము: సదరు వ్యక్తి ఇప్పటికే ఈ షిఫ్ట్‌కు కేటాయించబడ్డారు.',
  NLSOpsSitesErrorRoleCeiling: 'రిలీఫ్ కేటాయించలేము: సభ్యుల పాత్ర పరిమితి డ్యూటీ కేటాయింపును నిరోధిస్తుంది.',
  NLSOpsSitesErrorGeneric: 'రిలీఫ్ కేటాయించడం విఫలమైంది.',
  NLSOpsSitesErrorNotFound: 'రికార్డ్ లేదా అభ్యర్థన కనుగొనబడలేదు.',
  NLSOpsSitesErrorMissingAttributes: 'అభ్యర్థనలో అవసరమైన రిలీఫ్ లక్షణాలు లేవు.',
  NLSOpsSitesErrorInactivePerson: 'రిలీఫ్ కేటాయించలేము: సదరు వ్యక్తి వర్క్‌స్పేస్‌లో నిష్క్రియంగా ఉన్నారు.',
  NLSOpsRequestsUnassigned: 'కేటాయించబడలేదు',
  NLSOpsRequestsDetailUnassigned: 'కేటాయించబడలేదు',
  NLSOpsSitesIncidentsSubtitle: 'సంఘటనలు (పరిమితం) · క్లయింట్ ఫిర్యాదులు · సరఫరా అభ్యర్థనలు · సూపర్‌వైజర్ సైట్ ఆడిట్‌లు',
  NLSOpsSitesIncidentsTitle: 'సంఘటనలు',
  NLSOpsSitesRestrictedTag: 'పరిమితం',
  NLSOpsSitesAuditScoresTitle: 'సైట్ ఆడిట్ స్కోర్లు',
  NLSOpsSitesSupervisorRegisterTag: 'సూపర్‌వైజర్ రిజిస్టర్',
  NLSOpsSitesColSite: 'సైట్',
  NLSOpsSitesColLastAudit: 'చివరి ఆడిట్',
  NLSOpsSitesColScore: 'స్కోరు',
  NLSOpsSitesRecordAuditBtn: 'ఆడిట్‌ను రికార్డ్ చేయండి',
  NLSOpsSitesComplaintsSupplyTitle: 'ఫిర్యాదులు మరియు సరఫరా అభ్యర్థనలు',
  NLSOpsSitesNoIncidents: 'సంఘటనలు ఏవీ నమోదు కాలేదు.',
  NLSOpsSitesNoComplaintsSupply: 'ఫిర్యాదులు లేదా సరఫరా అభ్యర్థనలు ఏవీ లేవు.',
  NLSOpsSitesNoAudits: 'సైట్ ఆడిట్‌లు ఏవీ నమోదు కాలేదు.',
  NLSOpsSitesNoAuditTemplate: 'సూపర్‌వైజర్ సైట్ ఆడిట్ టెంప్లేట్ ఏదీ కాన్ఫిగర్ చేయబడలేదు.',
  NLSOpsSitesOpenTemplatesBtn: 'టెంప్లేట్‌లను తెరవండి',
} satisfies Partial<NlsStringMap>

export default teStringsNls
